































import { Component, Vue, PropSync } from 'vue-property-decorator'

@Component
export default class LabelPrintDialogComponent extends Vue {
  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  /* 印刷枚数 */
  count = 1

  /**
   * 初期化
   */
  reset() {
    this.count = 1
  }

  /**
   * キャンセルボタンのクリック
   */  
  onCancel() {
    this.dialog = false
    this.reset()
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", this.count)
    this.reset()
  }

}
